<template>
  <div class="page full-page">
    <!-- <video-bg v-if="!isMobile" source="static/videos/2.mp4"></video-bg> -->
    <div class="warning-container">
      <div class="warning-logo">
        <img class="logo-img" src="@images/logo.png" />
      </div>

      <div class="warning-tips-list">
        <div class="item">
          <h5 class="title">1.</h5>
          <p class="text">10,000 元派对金悬赏夜计划</p>
        </div>
        <div class="item">
          <h5 class="title">2.</h5>
          <p class="text">跟着城市大使疯玩你的城</p>
        </div>
        <div class="item">
          <h5 class="title">3.</h5>
          <p class="text">早鸟票派对不迟到</p>
        </div>
      </div>

      <router-link to="/calendar" tag="div" class="button btn-pink btn-block confirm-btn">
        <strong>知道了</strong>
      </router-link>
    </div>
  </div>
</template>

<script>
import VideoBg from '@components/VideoBg'
import { verify } from '@/utils'

export default {
  name: 'Warning',
  components: {
    VideoBg
  },
  data () {
    return {
      isMobile: ''
    }
  },
  mounted () {
    if (verify.isWeixin()) {
      let _url = window.location.href
      let shareInfo = {
        title: '百城绝对跨年夜计划',
        desc: '会玩的都在这里',
        imgUrl: this.$apiConfig.domain + '/static/share_icon.png',
      }
      this.WXConfig.wxShowMenu(_url, shareInfo)
    }
    if (verify.isMobile()) {
      this.isMobile = true
    } else {
      this.isMobile = false
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  background: url('~@static/mobile_bg3.jpg') no-repeat center top;
  background-size: cover;
  @include respond-to(desktop) {
    min-height: 100%;
    background: url('~@static/pc/bg3.jpg') no-repeat center top;
    background-size: cover;
    background-attachment: fixed;
  }
}
.warning-container {
  position: absolute;
  @include center();
  width: 100%;
  padding: 0 30px;
  text-align: center;
  @include respond-to(desktop) {
    width: 600px;
    .confirm-btn {
      width: 315px;
      margin: 0 auto;
    }
  }
}
.warning-title {
  text-align: center;
  font-size: 4rem;
  font-weight: bold;
  color: #fff;
}
.warning-logo {
  width: 100%;
  margin-bottom: 20px;
  text-align: center;
  @include respond-to(desktop) {
    margin-bottom: 0;
  }
  .logo-img {
    width: 60%;
    @include respond-to(screen-lg) {
      width: 70%;
    }
    @include respond-to(desktop) {
      width: 266px;
    }
  }
}
.warning-tips-list {
  padding: 24px 0 50px;
  .item {
    margin-bottom: 15px;
    font-weight: bold;
    font-size: 2rem;
    text-align: center;
    letter-spacing: 0.05em;
    color: #fff;
    @include respond-to(desktop) {
      display: inline-block;
      width: 30%;
      margin: 0 1%;
      &:last-child {
        padding: 0 20px;
      }
    }
    .title {
      font-family: "AbsolutHeadline";
      font-size: 4rem;
      text-align: center;
      color: nth($pink, 1);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Warning.vue